<h2 mat-dialog-title class="text-xl font-bold mb-4 px-6 py-4 border-b">
  {{ isEditMode ? 'Editar Teléfono' : 'Agregar Teléfono' }}
</h2>

<mat-dialog-content class="overflow-y-auto max-h-full">
  <form [formGroup]="createForm" class="grid grid-cols-2 gap-4 p-5">

    <!-- Prefijo -->
    <mat-form-field class="col-span-1">
      <mat-label>Prefijo</mat-label>
      <input matInput formControlName="prefix" placeholder="Ej: +504" inputmode="numeric" required />
      <mat-error *ngIf="createForm.get('prefix')?.hasError('required')">
        El prefijo es obligatorio.
      </mat-error>
      <mat-error *ngIf="createForm.get('prefix')?.hasError('pattern')">
         Solo se permiten números y opcionalmente un "+" al inicio.
      </mat-error>
    </mat-form-field>

    <!-- Número -->
    <mat-form-field class="col-span-1">
      <mat-label>Número</mat-label>
      <input matInput formControlName="phone" placeholder="Ej: 9876-5432" inputmode="numeric" [mask]="phoneMask"
        required />
      <mat-error *ngIf="createForm.get('phone')?.hasError('required')">
        El número es obligatorio.
      </mat-error>
      <mat-error *ngIf="createForm.get('phone')?.hasError('pattern')">
        Ingrese un número válido (solo dígitos, entre 6 y 15 máximo).
      </mat-error>
    </mat-form-field>



    <!-- Tipo -->
    <mat-form-field class="col-span-2">
      <mat-label>Tipo</mat-label>
      <mat-select formControlName="typeId" [compareWith]="comparePhoneType" required>
        <mat-option *ngFor="let option of phoneTypeOptions" [value]="option._id">
          {{ option.type }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="createForm.get('typeId')?.hasError('required')">
        El tipo de teléfono es obligatorio.
      </mat-error>
    </mat-form-field>

    <!-- Teléfono Principal -->
    <div class="col-span-1 flex items-center">
      <span class="slide">¿Teléfono Principal?</span>
      <mat-slide-toggle formControlName="isPrincipal" color="primary"></mat-slide-toggle>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-between items-center p-6 border-t mt-6">
  <button mat-button mat-dialog-close class="px-6 py-2">Cancelar</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="createForm.invalid" class="px-6 py-2">
    {{ isEditMode ? 'Actualizar' : 'Guardar' }}
  </button>
</mat-dialog-actions>